export default {
  row1 : [
  {
    column: "column1",
    columnWidth: "100%",
    rows: {
      row1: [
        {
          name: "remarks",
          actionText: "Remarks",
          component: "textarea",
          height : 90,
          width : "100%",
          rows: 1,
          maxRows: 1,
          required: true,
          requiredMessage: "Please enter remarks"
        },
      ],
      row2 : [
        {
          name: "exportUDFRemarksCcl",
          actionText: "Do you want to proceed?",
          component: "typographytext",
          width : "100%",
        },
      ]
    },
  },
]
};
